export default __webpack_public_path__ + "static/media/wB.96bb1cf5.svg";